import { Radio } from '../index'
import Validation from '../../wizard/Validation'
import PropTypes from 'prop-types'

const RadioWiz = (props) => {
    const dataFieldText =
        props.keyName.substring(props.keyName.lastIndexOf('.') + 1) ||
        props.keyName
    const labelFieldText = props.keyName
        .split('.')
        .map((t) => parseInt(t) || t)
        .filter((i) => isNaN(i))
        .join('.')
    const validationFieldText = props.keyName
        .split('.')
        .map((t, i) =>
            i === 0 && props.idx !== undefined ? `${t}.${props.idx}` : t
        )
        .join('.')

    const form = props.name ? props.wiz.form?.[props.name] : props.wiz.form
    const setter = props.setRow ? props.setRow : props.wiz.setValue
    const value = props.value
        ? props.value
        : props.row
        ? props.row?.[dataFieldText]
        : form?.[dataFieldText]

    if (props.hide) return null

    return (
        <Validation wiz={props.wiz} field={validationFieldText}>
            <Radio
                vertical={props.vertical}
                id={props.id || labelFieldText}
                title={props.title || props.wiz.getLabel(labelFieldText)}
                readOnly={props.readOnly}
                label={
                    !props.hideLabel &&
                    (props.label || props.wiz.getLabel(labelFieldText))
                }
                tooltipText={props.wiz.getToolTip(
                    props.keyName || labelFieldText || dataFieldText
                )}
                onChange={(e) => {
                    setter(dataFieldText, e.target.value)
                    if (props.clear) props.clear(e.target.value)
                }}
                options={props.options}
                value={value}
                disabled={props.disabled}
            />
        </Validation>
    )
}
export default RadioWiz

RadioWiz.propTypes = {
    wiz: PropTypes.object.isRequired,
    name: PropTypes.string,
    keyName: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    hideLabel: PropTypes.bool,
    readOnly: PropTypes.bool,
    setRow: PropTypes.func,
    label: PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.string,
    row: PropTypes.object,
    vertical: PropTypes.bool,
    clear: PropTypes.func,
    hide: PropTypes.bool,
}
